export default "__VITE_ASSET__885de382__"